export const FETCH_CONFIGS = 'FETCH_CONFIGS';
export const SAVE_CONFIGS = 'SAVE_CONFIGS';